/**
 * Shared modal styles
 */

import { COLORS } from '../../lib/constants';

export const modalStyles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  modal: {
    backgroundColor: COLORS.parchment,
    borderRadius: 0,
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    border: `1px solid ${COLORS.graphite}20`,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: `1px solid ${COLORS.graphite}15`,
  },
  title: {
    margin: 0,
    fontSize: '24px',
    color: COLORS.graphite,
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: 0,
    border: 'none',
    backgroundColor: 'transparent',
    color: COLORS.graphite,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  content: {
    padding: '24px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '6px',
  },
  label: {
    fontSize: '16px',
    color: COLORS.graphite,
  },
  required: {
    color: '#dc2626',
    marginLeft: '2px',
  },
  input: {
    padding: '12px 14px',
    fontSize: '16px',
    borderRadius: 0,
    border: `1px solid ${COLORS.graphite}30`,
    backgroundColor: '#fff',
    color: COLORS.graphite,
    outline: 'none',
    transition: 'border-color 0.2s ease',
  },
  textarea: {
    padding: '12px 14px',
    fontSize: '16px',
    borderRadius: 0,
    border: `1px solid ${COLORS.graphite}30`,
    backgroundColor: '#fff',
    color: COLORS.graphite,
    outline: 'none',
    resize: 'vertical' as const,
    minHeight: '100px',
  },
  select: {
    padding: '12px 14px',
    fontSize: '16px',
    borderRadius: 0,
    border: `1px solid ${COLORS.graphite}30`,
    backgroundColor: '#fff',
    color: COLORS.graphite,
    outline: 'none',
    cursor: 'pointer',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '20px 24px',
    borderTop: `1px solid ${COLORS.graphite}15`,
  },
  cancelButton: {
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: 0,
    border: `1px solid ${COLORS.graphite}30`,
    backgroundColor: 'transparent',
    color: COLORS.graphite,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  submitButton: {
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: '9999px',
    border: 'none',
    backgroundColor: COLORS.royalBlue,
    color: '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  submitButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  inputError: {
    border: '1px solid #dc2626',
  },
  errorText: {
    fontSize: '14px',
    color: '#dc2626',
    marginTop: '4px',
  },
  description: {
    fontSize: '16px',
    color: COLORS.graphite,
    opacity: 0.8,
    marginBottom: '16px',
    lineHeight: 1.5,
  },
  // Status views (success/error)
  statusContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 24px',
    textAlign: 'center' as const,
    gap: '16px',
  },
  statusIcon: {
    marginBottom: '8px',
  },
  statusTitle: {
    fontSize: '24px',
    color: COLORS.graphite,
    margin: 0,
  },
  statusMessage: {
    fontSize: '16px',
    color: COLORS.graphite,
    opacity: 0.8,
    margin: 0,
    maxWidth: '360px',
    lineHeight: 1.5,
  },
  statusButton: {
    marginTop: '16px',
    padding: '14px 28px',
    fontSize: '16px',
    borderRadius: '9999px',
    border: 'none',
    backgroundColor: COLORS.royalBlue,
    color: '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
};

export function getCloseButtonStyle(isHovered: boolean): React.CSSProperties {
  return {
    ...modalStyles.closeButton,
    backgroundColor: isHovered ? `${COLORS.graphite}10` : 'transparent',
  };
}
